import React, { useEffect } from 'react';
import Spinner from '@atlaskit/spinner';
import { PermissionGenericErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/permission-generic-error-boundary/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4';
import { usePlansItems } from '@atlassian/jira-plans-item-store';
import { arjSettingsFinancialYearResource } from '@atlassian/jira-router-resources-advanced-roadmaps-settings/src/services/financial-year';
import { PermissionGenericError } from '@atlassian/jira-standard-errors/src/common/utils/permission-generic-error/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { FinancialYearDates } from './ui';

export const FinancialYearDatesSettingsPage = () => (
	<PermissionGenericErrorBoundary>
		<FinancialYearDatesSettingsPageComponent />
	</PermissionGenericErrorBoundary>
);

export const FinancialYearDatesSettingsPageComponent = () => {
	const { data, loading } = useResource(arjSettingsFinancialYearResource);
	const [{ items }, { load }] = usePlansItems();

	useEffect(() => {
		getWillShowNav4() && load();
	}, [load]);

	const isPlansAdmin = fg('plans-settings-pages-permission-check')
		? Boolean(items?.links?.settings?.isVisible)
		: true;

	if (loading || data === null || (items === null && fg('plans-settings-pages-permission-check'))) {
		return <Spinner size="large" />;
	}

	if (!isPlansAdmin && fg('plans-settings-pages-permission-check')) {
		const permissionError = new PermissionGenericError('User is not Plans Admin');
		fireErrorAnalytics({
			meta: {
				id: 'PlansFinancialYearSettingsPermissionError',
				packageName: 'jiraPortfolio3FinancialYearDates',
			},
			error: permissionError,
		});
		throw permissionError;
	}

	const { month } = data;

	return <FinancialYearDates startMonth={month} />;
};
